import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Avatar,
  Grid,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  ChevronLeft,
  ChevronRight,
  Star,
} from '@mui/icons-material';


const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const testimonials = [
    {
      id: 1,
      name: 'Rohit S',
      rating: 5,
      text: 'Buying a plot in Guhagar felt like uncovering a hidden paradise. The moment I saw the greenery, the calm, and the sea breeze — I knew this was more than just land, it was peace of mind. The entire process was transparent, and the team made me feel confident at every step. I’m proud to own a piece of nature that’s both beautiful and valuable.',
      avatar: 'R',
    },
    {
      id: 2,
      name: 'Sushil S',
      rating: 5,
      text: 'We always wanted a second home near the coast, away from the city rush. Guhagar offered us that dream. The location is untouched, pure, and the plot we purchased is perfect for our future home. What stood out was the sincerity and clarity from the team — no surprises, no fine print. Just honest people helping families invest in their future',
      avatar: 'S',
    },
    {
      id: 3,
      name: 'Rutuja K',
      rating: 5,
      text: "Guhagar is one of the rare places where nature and growth go hand in hand. I invested in a plot here not just for the serenity but for long-term value. Watching nearby development pick up while still enjoying the quiet has been reassuring. The purchase process was smooth, with complete legal support and prompt updates. I’d recommend it to anyone looking for both beauty and potential",
      avatar: 'R',
    },
  ];

  const handlePrevious = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const handleNext = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const renderStars = (rating) => {
    return Array.from({ length: rating }, (_, index) => (
      <Star key={index} sx={{ color: '#FFD700', fontSize: 20 }} />
    ));
  };

  return (
    <Box sx={{ py: 8, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{ mb: 2, fontWeight: 700, color: 'primary.main' }}
        >
          Testimonial
        </Typography>

        <Box sx={{ position: 'relative', mt: 6 }}>
          <Card
            elevation={4}
            sx={{
              maxWidth: 800,
              mx: 'auto',
              p: 4,
              textAlign: 'center',
              position: 'relative',
            }}
          >
            <CardContent>
              <Box sx={{ mb: 3 }}>
                {renderStars(testimonials[currentTestimonial].rating)}
              </Box>
              
              <Typography
                variant="h6"
                component="p"
                sx={{
                  mb: 4,
                  fontStyle: 'italic',
                  lineHeight: 1.8,
                  color: 'text.secondary',
                }}
              >
                "{testimonials[currentTestimonial].text}"
              </Typography>

              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                <Avatar
                  sx={{
                    width: 60,
                    height: 60,
                    backgroundColor: 'primary.main',
                    fontSize: '1.5rem',
                    fontWeight: 600,
                  }}
                >
                  {testimonials[currentTestimonial].avatar}
                </Avatar>
                <Box>
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{ fontWeight: 600, color: 'primary.main' }}
                  >
                    {testimonials[currentTestimonial].name}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <IconButton
            onClick={handlePrevious}
            sx={{
              position: 'absolute',
              left: { xs: 10, md: -60 },
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'white',
              boxShadow: theme.shadows[4],
              '&:hover': {
                backgroundColor: 'grey.100',
              },
            }}
          >
            <ChevronLeft />
          </IconButton>

          <IconButton
            onClick={handleNext}
            sx={{
              position: 'absolute',
              right: { xs: 10, md: -60 },
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'white',
              boxShadow: theme.shadows[4],
              '&:hover': {
                backgroundColor: 'grey.100',
              },
            }}
          >
            <ChevronRight />
          </IconButton>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 1,
            mt: 4,
          }}
        >
          {testimonials.map((_, index) => (
            <Box
              key={index}
              onClick={() => setCurrentTestimonial(index)}
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: index === currentTestimonial ? 'primary.main' : 'grey.300',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: 'primary.main',
                },
              }}
            />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Testimonials; 